import React from "react";
import styles from "./CountryNavbarMobile.module.css";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { HiMenuAlt3 } from "react-icons/hi";
import logo from "../../assets/images/logo.svg";
import { connect } from "react-redux";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

function CountryNavbarMobile(props) {
  const login = props.login;

  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div className={clsx(classes.list)} role="presentation">
      <List>
        <div className={styles.navopt}>
          <Link
            to="/"
            className={styles.text}
            onClick={toggleDrawer(anchor, false)}
          >
            <span>Home</span>
          </Link>
          <p className={styles.text}>Contact us</p>
          <p className={styles.text}>FAQ's</p>
          {login ? (
            <Link to="/dashboard/home">
              <button className={styles.login}>My Account</button>
            </Link>
          ) : (
            <Link to="/login">
              <button className={styles.login}>Login</button>
            </Link>
          )}
        </div>
      </List>
    </div>
  );

  return (
    <div className={styles.navmobile}>
      <div className={styles.nav}>
        <Link to="/">
          <img src={logo} alt="Logo" className={styles.logoa} />
        </Link>
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button
              onClick={toggleDrawer("left", true)}
              style={{ outline: "none" }}
            >
              <HiMenuAlt3 className={styles.burger} />
            </Button>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer("left", false)}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  login: state.Login.login,
});

export default connect(mapStateToProps)(CountryNavbarMobile);
